// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useHistory, useLocation } from "react-router-dom";
// import { useSnackbar } from "react-simple-snackbar";
// import { makeStyles } from "@material-ui/core/styles";
// import {
//   Container,
//   Typography,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   Paper,
//   TableContainer,
//   Box,
//   TextField,
// } from "@material-ui/core";
// import ArrowBackIcon from "@material-ui/icons/ArrowBack";
// import { getAllCategories } from "../../actions/categoryActions";
// import { createFuturePriceList, fetchFuturePriceList } from "../../actions/itemActions";


// const useStyles = makeStyles((theme) => ({
//   container: {
//     padding: theme.spacing(3),
//     maxWidth: 1200,
//   },
//   header: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     marginBottom: theme.spacing(3),
//   },
//   tableContainer: {
//     marginTop: theme.spacing(2),
//     maxHeight: "60vh",
//     borderRadius: theme.shape.borderRadius,
//     boxShadow: theme.shadows[2],
//   },
//   backButton: {
//     borderRadius: 20,
//   },
//   button: {
//     margin: theme.spacing(1),
//     borderRadius: 20,
//     padding: theme.spacing(1, 3),
//     textTransform: "none",
//   },
//   textField: {
//     "& .MuiOutlinedInput-root": {
//       "& fieldset": {
//         borderColor: "#ddd",
//       },
//       "&:hover fieldset": {
//         borderColor: "#ef7f1a",
//       },
//       "&.Mui-focused fieldset": {
//         borderColor: "#ef7f1a",
//       },
//     },
//   },
//   datePickerContainer: {
//     marginBottom: theme.spacing(3),
//     display: "flex",
//     alignItems: "center",
//     gap: theme.spacing(2),
//   },
//   errorText: {
//     color: theme.palette.error.main,
//     fontSize: "0.875rem",
//   },
//   infoText: {
//     color: theme.palette.text.secondary,
//     fontSize: "0.875rem",
//     marginLeft: theme.spacing(2),
//   },
// }));

// const FuturePriceList = () => {
//   const classes = useStyles();
//   const dispatch = useDispatch();
//   const history = useHistory();
//   const location = useLocation();
//   const [openSnackbar] = useSnackbar();
//   const selectedItems = location.state?.selectedItems || [];
//   const { futurePrices } = useSelector((state) => state.items);

//   // State for price list data
//   const [priceData, setPriceData] = useState(
//     selectedItems.map((item) => {
//       // Find the latest future price for this item
//       const latestPrice = futurePrices
//         .filter((p) => p.itemId === item._id && !p.isApplied)
//         .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];
//       return {
//         _id: item._id,
//         itemName: item.itemName,
//         salePrice: latestPrice ? latestPrice.salePrice.toString() : "", // Pre-fill with latest price
//         errors: { salePrice: "" },
//       };
//     })
//   );
//   // State for effective date
//   const [effectiveDate, setEffectiveDate] = useState("");
//   const [dateError, setDateError] = useState("");

//   useEffect(() => {
//     dispatch(getAllCategories()); // Optional
//     dispatch(fetchFuturePriceList()); // Fetch future prices to pre-fill
//   }, [dispatch]);

//   // Validate prices and effective date
//   const validateForm = () => {
//     let isValid = true;

//     // Validate prices
//     const updatedPriceData = priceData.map((item) => {
//       const errors = { salePrice: "" };
//       if (item.salePrice && isNaN(Number(item.salePrice))) {
//         errors.salePrice = "Price must be a valid number";
//         isValid = false;
//       }
//       if (item.salePrice && Number(item.salePrice) < 0) {
//         errors.salePrice = "Price cannot be negative";
//         isValid = false;
//       }
//       return { ...item, errors };
//     });
//     setPriceData(updatedPriceData);

//     // Validate effective date
//     if (!effectiveDate) {
//       setDateError("Please select an effective date");
//       isValid = false;
//     } else {
//       const selectedDate = new Date(effectiveDate);
//       const today = new Date();
//       today.setHours(0, 0, 0, 0);
//       if (selectedDate <= today) {
//         setDateError("Effective date must be in the future");
//         isValid = false;
//       } else {
//         setDateError("");
//       }
//     }

//     return isValid;
//   };

//   // Handle price change for an item
//   const handlePriceChange = (index, value) => {
//     setPriceData((prev) =>
//       prev.map((item, i) =>
//         i === index
//           ? {
//               ...item,
//               salePrice: value,
//               errors: { ...item.errors, salePrice: "" },
//             }
//           : item
//       )
//     );
//   };

//   // Handle form submission
//   const handleSubmit = async () => {
//     if (!validateForm()) {
//       openSnackbar("Please correct the errors before submitting");
//       return;
//     }

//     // Check if at least one item has a price
//     const hasPrices = priceData.some((item) => item.salePrice !== "");
//     if (!hasPrices) {
//       openSnackbar("Please set at least one price");
//       return;
//     }

//     // Prepare payload
//     const futurePriceList = priceData
//       .filter((item) => item.salePrice !== "")
//       .map((item) => ({
//         itemId: item._id,
//         salePrice: Number(item.salePrice),
//         effectiveDate,
//       }));

//     try {
//       await dispatch(createFuturePriceList(futurePriceList, openSnackbar));
//       history.push("/ItemsList");
//     } catch (error) {
//       console.error("Error creating future price list:", error);
//       openSnackbar("Failed to create future price list");
//     }
//   };

//   const handleBack = () => {
//     history.push("/ItemsList");
//   };

//   return (
//     <Container className={classes.container}>
//       <Box className={classes.header}>
//         <Button
//           variant="outlined"
//           color="primary"
//           startIcon={<ArrowBackIcon />}
//           onClick={handleBack}
//           className={classes.backButton}
//         >
//           Back to ItemList
//         </Button>
//         <Typography variant="h4">Schedule Future Price List</Typography>
//         <div style={{ width: 100 }} />
//       </Box>

//       {selectedItems.length === 0 ? (
//         <Typography variant="h6" color="textSecondary" align="center">
//           No items selected. Please select items from the Items List.
//         </Typography>
//       ) : (
//         <>
//           {/* Effective Date Picker */}
//           <Box className={classes.datePickerContainer}>
//             <TextField
//               label="Effective Date"
//               type="date"
//               value={effectiveDate}
//               onChange={(e) => setEffectiveDate(e.target.value)}
//               InputLabelProps={{ shrink: true }}
//               className={classes.textField}
//               error={!!dateError}
//               helperText={dateError}
//             />
//             <Typography className={classes.infoText}>
//               Prices will automatically take effect on the selected date.
//             </Typography>
//           </Box>

//           {/* Price List Table */}
//           <TableContainer component={Paper} className={classes.tableContainer}>
//             <Table stickyHeader size="small">
//               <TableHead>
//                 <TableRow>
//                   <TableCell>S.No</TableCell>
//                   <TableCell>Name</TableCell>
//                   <TableCell>Current Sale Price</TableCell>
//                   <TableCell>New Sale Price</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {priceData.map((item, index) => (
//                   <TableRow key={item._id}>
//                     <TableCell>{index + 1}</TableCell>
//                     <TableCell>{item.itemName}</TableCell>
//                     <TableCell>
//                       {selectedItems[index].units.sale.price
//                         ? `฿${selectedItems[index].units.sale.price
//                             .toString()
//                             .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
//                         : "N/A"}
//                     </TableCell>
//                     <TableCell>
//                       <TextField
//                         variant="outlined"
//                         type="number"
//                         value={item.salePrice}
//                         onChange={(e) => handlePriceChange(index, e.target.value)}
//                         size="small"
//                         className={classes.textField}
//                         error={!!item.errors.salePrice}
//                         helperText={item.errors.salePrice}
//                       />
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>

//           <Box display="flex" justifyContent="flex-end" mt={2}>
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={handleSubmit}
//               className={classes.button}
//             >
//               Schedule Price List
//             </Button>
//           </Box>
//         </>
//       )}
//     </Container>
//   );
// };

// export default FuturePriceList;

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { useSnackbar } from "react-simple-snackbar";
import { makeStyles } from "@material-ui/core/styles";
import {
  Container,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Box,
  TextField,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { getAllCategories } from "../../actions/categoryActions";
import { createFuturePriceList, fetchFuturePriceList } from "../../actions/itemActions";


const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
    maxWidth: 1200,
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(3),
  },
  tableContainer: {
    marginTop: theme.spacing(2),
    maxHeight: "60vh",
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[2],
  },
  backButton: {
    borderRadius: 20,
  },
  button: {
    margin: theme.spacing(1),
    borderRadius: 20,
    padding: theme.spacing(1, 3),
    textTransform: "none",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#ddd",
      },
      "&:hover fieldset": {
        borderColor: "#ef7f1a",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#ef7f1a",
      },
    },
  },
  datePickerContainer: {
    marginBottom: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  errorText: {
    color: theme.palette.error.main,
    fontSize: "0.875rem",
  },
  infoText: {
    color: theme.palette.text.secondary,
    fontSize: "0.875rem",
    marginLeft: theme.spacing(2),
  },
}));

const FuturePriceList = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [openSnackbar] = useSnackbar();
  const selectedItems = location.state?.selectedItems || [];
  const { futurePrices } = useSelector((state) => state.items);

  // State for price list data
  const [priceData, setPriceData] = useState(
    selectedItems.map((item) => {
      const latestPrice = futurePrices
        .filter((p) => p.itemId === item._id && !p.isApplied)
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];
      return {
        _id: item._id,
        itemName: item.itemName,
        salePrice: latestPrice ? latestPrice.salePrice.toString() : "",
        errors: { salePrice: "" },
      };
    })
  );
  // State for effective date and time
  const [effectiveDateTime, setEffectiveDateTime] = useState("");
  const [dateError, setDateError] = useState("");

  useEffect(() => {
    dispatch(getAllCategories());
    dispatch(fetchFuturePriceList());
  }, [dispatch]);

  // Validate prices and effective date
  const validateForm = () => {
    let isValid = true;

    // Validate prices
    const updatedPriceData = priceData.map((item) => {
      const errors = { salePrice: "" };
      if (item.salePrice && isNaN(Number(item.salePrice))) {
        errors.salePrice = "Price must be a valid number";
        isValid = false;
      }
      if (item.salePrice && Number(item.salePrice) < 0) {
        errors.salePrice = "Price cannot be negative";
        isValid = false;
      }
      return { ...item, errors };
    });
    setPriceData(updatedPriceData);

    // Validate effective date and time
    if (!effectiveDateTime) {
      setDateError("Please select a date and time");
      isValid = false;
    } else {
      const selectedDate = new Date(effectiveDateTime);
      const now = new Date();
      if (isNaN(selectedDate.getTime()) || selectedDate <= now) {
        setDateError("Date and time must be in the future");
        isValid = false;
      } else {
        setDateError("");
      }
    }

    return isValid;
  };

  // Handle price change for an item
  const handlePriceChange = (index, value) => {
    setPriceData((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
              ...item,
              salePrice: value,
              errors: { ...item.errors, salePrice: "" },
            }
          : item
      )
    );
  };

  // Handle form submission
  const handleSubmit = async () => {
    if (!validateForm()) {
      openSnackbar("Please correct the errors before submitting");
      return;
    }

    // Check if at least one item has a price
    const hasPrices = priceData.some((item) => item.salePrice !== "");
    if (!hasPrices) {
      openSnackbar("Please set at least one price");
      return;
    }

    // Prepare payload
    const futurePriceList = priceData
      .filter((item) => item.salePrice !== "")
      .map((item) => ({
        itemId: item._id,
        salePrice: Number(item.salePrice),
        effectiveDate: new Date(effectiveDateTime).toISOString(),
      }));

    try {
      await dispatch(createFuturePriceList(futurePriceList, openSnackbar));
      history.push("/ItemsList");
    } catch (error) {
      console.error("Error creating future price list:", error);
      openSnackbar("Failed to create future price list");
    }
  };

  const handleBack = () => {
    history.push("/ItemsList");
  };

  return (
    <Container className={classes.container}>
      <Box className={classes.header}>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          className={classes.backButton}
        >
          Back to ItemList
        </Button>
        <Typography variant="h4">Schedule Future Price List</Typography>
        <div style={{ width: 100 }} />
      </Box>

      {selectedItems.length === 0 ? (
        <Typography variant="h6" color="textSecondary" align="center">
          No items selected. Please select items from the Items List.
        </Typography>
      ) : (
        <>
          {/* Effective Date and Time Picker */}
          <Box className={classes.datePickerContainer}>
            <TextField
              label="Effective Date and Time"
              type="datetime-local"
              value={effectiveDateTime}
              onChange={(e) => setEffectiveDateTime(e.target.value)}
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              error={!!dateError}
              helperText={dateError}
            />
            <Typography className={classes.infoText}>
              Prices will automatically take effect at the selected date and time.
            </Typography>
          </Box>

          {/* Price List Table */}
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell>S.No</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Current Sale Price</TableCell>
                  <TableCell>New Sale Price</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {priceData.map((item, index) => (
                  <TableRow key={item._id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{item.itemName}</TableCell>
                    <TableCell>
                      {selectedItems[index].units.sale.price
                        ? `฿${selectedItems[index].units.sale.price
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                        : "N/A"}
                    </TableCell>
                    <TableCell>
                      <TextField
                        variant="outlined"
                        type="number"
                        value={item.salePrice}
                        onChange={(e) => handlePriceChange(index, e.target.value)}
                        size="small"
                        className={classes.textField}
                        error={!!item.errors.salePrice}
                        helperText={item.errors.salePrice}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              className={classes.button}
            >
              Schedule Price List
            </Button>
          </Box>
        </>
      )}
    </Container>
  );
};

export default FuturePriceList;